import { RowRecord } from '@luminovo/http-client';
import { typeSafeObjectKeys } from '../../../utils/typingUtils';

export function parseRawOriginalLine(rawOriginalLine: RowRecord | undefined): string[] | undefined {
    if (rawOriginalLine === undefined) {
        return undefined;
    }
    return typeSafeObjectKeys(rawOriginalLine).map((key) => String(rawOriginalLine[key] ?? ''));
}
